import { render, staticRenderFns } from "./NevronColorPicker.vue?vue&type=template&id=1438f707&scoped=true&"
import script from "./NevronColorPicker.vue?vue&type=script&lang=ts&"
export * from "./NevronColorPicker.vue?vue&type=script&lang=ts&"
import style0 from "./NevronColorPicker.vue?vue&type=style&index=0&id=1438f707&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1438f707",
  null
  
)

export default component.exports